<app-schedules-tab
  [job-id]="jobId"
  [opportunity-id]="opportunityId"
  [default-user-on-create]="assignedUser"
  [metadata-type]="metadataType"
  [viewing-from-record-view]="true"
  [record-details]="recordDetails">
</app-schedules-tab>